import React, { useState } from 'react';
import { TLanguageIDs, IGroupsOfMediaSettings } from 'types';
import EmblaCarouselForInfo from 'components/EmblaCarousel/EmblaCarouselForInfo/EmblaCarouselForInfo';
import BlobDownloader from 'components/UploaderAndDownloader/BlobDownloader';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './Carousel.module.scss';

interface ICarousel {
	group: IGroupsOfMediaSettings;
	languageId: TLanguageIDs;
	selectedStyleLanguage: TLanguageIDs | null;
}

const Carousel: React.FC<ICarousel> = ({ group, languageId, selectedStyleLanguage }) => {
	const [actualPageOfCarousel, setActualPageOfCarousel] = useState<number>(0);

	const hasMediaFile = group.items.some((el) => el.mediaFileType === 1 || el.mediaFileType === 2);

	const filePathOfPdf = group.items.find((el) => el.mediaFileType === 3 && el.filePath)?.filePath || null;

	return (
		<div>
			{hasMediaFile ? (
				<EmblaCarouselForInfo
					onSetActualPageOfCarousel={setActualPageOfCarousel}
					items={group.items}
					languageId={languageId}
					selectedIndex={actualPageOfCarousel}
					selectedStyleLanguage={selectedStyleLanguage}
				/>
			) : (
				<div className={style.imgBlank}>
					<svg>
						<use xlinkHref={`${breadcrumbs}#twoHills`} />
					</svg>
				</div>
			)}
			{group.key === 'how_it_works' ? (
				<div className={style.downloadBtnWrapper}>
					<BlobDownloader
						filePath={filePathOfPdf}
						fileExtension="pdf"
						fileName="document"
						label="downloadPdfLabel"
					/>
				</div>
			) : null}
		</div>
	);
};

export default React.memo(Carousel);
